import request from '@/router/axios';

let urlPrefix = '/api/lab/labreport2mark';

/**
 * 获取报告附件下的批注列表
 * @param {String} expUid 报告记录ID
 */
export const getMarkList = expUid => {
    return request(`${urlPrefix}/queryByReport/${expUid}`)
}

/**
 * 获取竞赛报告下的批注列表
 * @param {String} expUid 报告记录ID
 */
export const getRaceMarkList = (uid, group) => {
    return request(`${urlPrefix}/queryRaceByReport/${uid}/${group}`)
}


/**
 * 添加批注
 * @param {*} data 
 */
export const addMark = data => {
    let promise = new Promise((resolve, reject) => {
        const  { type, text } = data
        if (text) {
            const json = JSON.parse(text)
            const {
                x,
                y,
                width,
                height
            } = json
            if (!x || !y || !width || !height)
                return reject(new Error('x y width or height is null or undefined'))
            switch (type) {
                case 'polyline': // 涂鸦
                    if (!json.points)
                        return reject(new Error('points is null or undefined'))
                    break;
                case 'ellipse': // 椭圆
                    if (!json.cx || !json.cy || !json.rx || !json.ry)
                        return reject(new Error('error message'))
                    break;
                case 'arrow': // 箭头
                    if (!json.x1 || !json.y1 || !json.x2 || !json.y2 || !json.points)
                        return reject(new Error('error message'))
                    break;
                case 'annotation': // 文本
                    if (!json.font)
                        return reject(new Error('error message'))
            }
        }
        return resolve(
            request(urlPrefix, {
                data
            }, 'post')
        )
    })
    return promise
};
/**
 * 修改批注
 * @param {*} data 
 */
export const updateMark = data => {
    return request(urlPrefix, {
        data
    }, 'put');
};

/** 
 *批量删除批注
 * @param {Array} data
 */
export const delMark = data => {
    return request(`${urlPrefix}/deleteBatch`, {
        data
    }, 'delete');
};